import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { isEmpty, size } from "lodash";
import toast from "react-hot-toast";

import { Link, withRouter } from "react-router-dom";

import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import Select from "react-select";
import { Formik, Field, ErrorMessage, Form } from "formik";
import * as Yup from "yup";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {createTestRequest} from "../../store/tests/actions"

class CreateTest extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
   
  }


  render() {
    const test  = this.state;
    return (
      <React.Fragment>
        <div className="page-content mb-2" >
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs title="Tests" breadcrumbItem="Create Test" />
            <Formik
              enableReinitialize={true}
              initialValues={{
                Title:
                        (test && test.Title) || "",
                UpperPriceLimit:
                        (test && test.UpperPriceLimit) || "",
                LowerPriceLimit: 
                        (test && test.LowerPriceLimit) || "",
                PreConditions:
                        (test && test.PreConditions) || "",
                AvgDuration:
                        (test && test.AvgDuration) || "",
                Description:
                        (test && test.Description) || "",
              }}
              validationSchema={Yup.object().shape({
                Title: Yup.string().required("Title is required"),
                Description: Yup.string()
                  .required("Description is required")
                  .min(100, "Description must be at least 100 characters"),
                PreConditions: Yup.string().required(
                  "PreConditions are required"
                ),
                LowerPriceLimit: Yup.number()
                  .required("LowerPriceLimit is required")
                  .min(0, "LowerPriceLimit must be greater than 0"),
                UpperPriceLimit: Yup.number()
                  .required("UpperPriceLimit is required")
                  .min(0, `UpperPriceLimit must be greater than 0`),
                AvgDuration: Yup.string().required("AvgDuration is required"),
                // check for type error
              })}
              onSubmit={values => {
                  const CreatedTest = {
                    Title: values.Title,
                    UpperPriceLimit: values.UpperPriceLimit,
                    LowerPriceLimit: values.LowerPriceLimit,
                    PreConditions: values.PreConditions, //needs to be changed
                    Description: values.Description,
                    AvgDuration: values.AvgDuration,
                  };
                  this.props.createTest(CreatedTest);
                } 
                  
                }
              
            >
              {({ errors, status, touched, values }) => (
                <Form>
                  <Row>
                    <Col xs="12">
                      <Card>
                        <CardBody>
                          <div
                            className="d-flex"
                            style={{ justifyContent: "space-between" }}
                          >
                            <div>
                              <CardTitle className="h4">
                                Test Information
                              </CardTitle>
                              <p className="card-title-desc">
                                Fill test information below
                              </p>
                            </div>
                            {/* <div className="form-check form-switch form-switch-md mb-3">
                             
                            </div> */}
                          </div>

                          <Row>
                            <Col sm="6">
                            <div className="mb-3">
                                                <Label className="form-label">
                                                  Test Title
                                                </Label>
                                                <Field
                                                  name="Title"
                                                  type="text"
                                                  className={
                                                    "form-control" +
                                                    (errors.Title &&
                                                      touched.Title
                                                      ? " is-invalid"
                                                      : "")
                                                  }
                                                />
                                                <ErrorMessage
                                                  name="Title"
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </div>
                                              <div className="mb-3">
                                                <Label className="form-label">
                                                  Preconditions
                                                </Label>
                                                <Field
                                                  name="PreConditions"
                                                  type="text"
                                                  className={
                                                    "form-control" +
                                                    (errors.PreConditions &&
                                                      touched.PreConditions
                                                      ? " is-invalid"
                                                      : "")
                                                  }
                                                />
                                                <ErrorMessage
                                                  name="PreConditions"
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </div>
                                              <div className="mb-3">
                                                <Label className="form-label">
                                                  Lower Price Limit
                                                </Label>
                                                <Field
                                                  name="LowerPriceLimit"
                                                  type="number"
                                                  className={
                                                    "form-control" +
                                                    (errors.LowerPriceLimit &&
                                                      touched.LowerPriceLimit
                                                      ? " is-invalid"
                                                      : "")
                                                  }
                                                >
                                                 
                                                </Field>
                                                <ErrorMessage
                                                  name="LowerPriceLimit"
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </div>
                                              <div className="mb-3">
                                                <Label className="form-label">
                                                  Average duration
                                                </Label>
                                                <Field
                                                  name="AvgDuration"
                                                  type="text"
                                                  className={
                                                    "form-control" +
                                                    (errors.AvgDuration &&
                                                      touched.AvgDuration
                                                      ? " is-invalid"
                                                      : "")
                                                  }
                                                >
                                                 
                                                </Field>
                                                <ErrorMessage
                                                  name="AvgDuration"
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                                </div>

                                              </Col>

                                              <Col sm="6">
                                              <div className="mb-3">
                                                <Label className="form-label">
                                                  Description
                                                </Label>
                                                <Field
                                                  name="Description"
                                                  type="text"
                                                  component="textarea"
                                                  rows="5"
                                                  className={
                                                    "form-control" +
                                                    (errors.Description &&
                                                      touched.Description
                                                      ? " is-invalid"
                                                      : "")
                                                  }
                                                />
                                                <ErrorMessage
                                                  name="Description"
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </div>
                                             
                                              <div className="mb-3">
                                                <Label className="form-label">
                                                  Upper Price Limit
                                                </Label>
                                                <Field
                                                  name="UpperPriceLimit"
                                                  type="number"
                                                  className={
                                                    "form-control" +
                                                    (errors.UpperPriceLimit &&
                                                      touched.UpperPriceLimit
                                                      ? " is-invalid"
                                                      : "")
                                                  }
                                                >
                                                  
                                                </Field>
                                                <ErrorMessage
                                                  name="UpperPriceLimit"
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </div>
                                             
                            
                            </Col>
                          </Row>
                          <div className="d-flex flex-wrap gap-2">
                            <Button type="submit" color="primary">
                              Create Test
                            </Button>
                            <Button
                              onClick={() => {
                                toast.error("Test Creation Cancelled");
                                this.props.history.push("/testslist");
                              }}
                              color="secondary"
                            >
                              Cancel
                            </Button>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

CreateTest.propTypes = {
  createTest: PropTypes.func,
  history: PropTypes.object,
  onDeleteService: PropTypes.func,
  className: PropTypes.any,
  onGetTests: PropTypes.func,
  Tests: PropTypes.array,
};

const mapStateToProps = state => {
  return {
    test: state.TestReducer.test,
  };
};

const mapDispatchToProps = dispatch => ({
    createTest: (test) =>
      dispatch(createTestRequest(test)),
  
  });
  

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CreateTest));